import moment from 'moment';
import { CustomCell } from '../../components/custom-cell';

export const DATE_FORMAT = 'DD.MM.YYYY';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const TABLE_ORDERS_IMPORTS_COLUMNS = [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		renderCell: params => CustomCell(params),
		sortable: false,
		filterable: false,
	},
	{
		headerName: 'Файл',
		field: 'filename',
		flex: 1,
		sortable: false,
		filterable: false,
	},
	{
		headerName: 'Дата',
		field: 'upload_at',
		flex: 1,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.upload_at) {
				return '';
			}

			return moment(row.upload_at).format(DATE_TIME_FORMAT);
		},
	},
	{
		headerName: 'Статус',
		field: 'status',
		flex: 1,
		sortable: false,
		filterable: false,
		valueGetter: (value, row) => {
			if (!row.status) {
				return '';
			}

			return row.status.name;
		},
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
